<template>
  <v-card class="justify-start" flat v-if="EspecifTecnica.length !== 0">
    <v-card-title class="headline primary--text text--lighten-1">
      Especificaciones
      <v-btn
        color="transparent"
        elevation="0"
        class="ma-2 white--text"
        :ripple="false"
        fab
        x-small
        :loading="statusFile.Loading"
        :disabled="statusFile.Loading"
        @click="() => generarPDF({ data: EspecifTecnica, ref: Articulo[0] })"
      >
        <IconPdf />
      </v-btn>
    </v-card-title>

    <v-divider color="#E0E0E0" class="mt-n3"></v-divider>
    <v-list-item two-line v-for="(item, i) in encabezados" :key="i">
      <v-list-item-content>
        <v-list-item-title>
          <span class="font-weight-bold text-uppercase">{{
            item.Descripcion
          }}</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          <EspecificacionesItem :grupo="item.Grupo" />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { saveAs } from "file-saver";
import EspecificacionesItem from "./EspecificacionesItem";
import { IconPdf } from "../Icons/";
export default {
  name: "EspecificacionesList",
  data() {
    return {
      controller: new AbortController(),
      statusFile: {
        Loading: false,
        Error: null,
      },
    };
  },
  computed: {
    ...mapState(["EspecifTecnica", "server", "Articulo"]),
    contenido: function () {
      return function (id) {
        return this.EspecifTecnica.filter(
          (x) => x.Grupo === id && x.Valor != ""
        );
      };
    },
    encabezados() {
      if (this.EspecifTecnica) {
        return this.EspecifTecnica.filter((x) => x.Codigo === 0);
      }
      return true;
    },
  },
  methods: {
    generarPDF({ data, ref }) {
      const params = {
        data,
        ref,
      };
      const config = { responseType: "blob" };
      const urlBase = `${this.server}PdfApp/especificaciones.php`;
      try {
        this.statusFile = { Loading: true };
        axios.post(urlBase, params, config).then((resp) => {
          saveAs(resp.data, `Ficha_${this.$route.params.articulo}.pdf`);
          this.statusFile = { Loading: false };
        });
      } catch (error) {
        this.statusFile = { Loading: false, Error: error };
      }
    },
  },
  components: { EspecificacionesItem, IconPdf },
};
</script>

<style></style>
